import {NetworkInstance} from "@goodgamestudios/world-assignment";
export class LiveInstanceVO extends NetworkInstance {
    constructor() {
        super();
        this._type = "Live";
    }
}
